import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GetRequestActivityByIdGQL } from './../../../../../generated/cloudapigql';
import { HeaderTemplateData } from '../dialog-data.interface';
import { SharedService } from '../../../../../services/shared.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

// export interface DialogData {
//     title: [];
//     type: number;
//     amount: number;
//     att: any [];
// }
export interface activityDetail extends HeaderTemplateData{
  activityId:string;
}

@UntilDestroy()
@Component({
  selector: 'activity-detail-dialog',
  templateUrl: 'activity-detail-dialog.html',
  styleUrls: ['activity-detail-dialog.scss']
})

export class ActivityDetailDialog implements OnInit {
  result: any = {};

  header: HeaderTemplateData;
  constructor(
    public dialogRef: MatDialogRef<ActivityDetailDialog>,
    private getRequestActivityByIdGQL: GetRequestActivityByIdGQL,
    public shareService:SharedService,
    @Inject(MAT_DIALOG_DATA) private _data: any
  ) {
    if (this._data != null) {
      this.header = _data
      let requestActivityId = this._data.activityId;

      if (requestActivityId) {

        this.getRequestActivityByIdGQL.fetch({
          ActivityId: requestActivityId
        }).pipe(untilDestroyed(this)).subscribe(x => {
          this.result = x.data.requestActivityById;

          if (this.result.requestFollowUp) {
            this.result.categoryType = "Follow Up";
          } else if (this.result.requestQuotation) {
            this.result.categoryType = "Quotation";
          } else if (this.result.requestEstimation) {
            this.result.categoryType = "Estimated Resolution";
          } else {
            this.result.categoryType = "Assignment";

          }
        }, error => {
          console.error(error)
        })

      }
    }
  }

  ngOnInit() {
  }

  downloadQuotation(url: string) {
    window.open(url);
  }

}
